import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

import { StyledButton } from "../../styled/button";

export interface IClearFormButtonProps {
  initialValues: Record<any, any>;
}

export const ClearFormButton: FC<IClearFormButtonProps> = props => {
  const { initialValues } = props;
  const form = useFormContext();

  const reset = () => {
    form.reset(initialValues);
  };

  return (
    <StyledButton size="small" onClick={reset} color="info" sx={{ minWidth: 80, mb: 1 }}>
      <FormattedMessage id="form.buttons.clear" />
    </StyledButton>
  );
};
